import React from "react";
import { Field } from "react-final-form";
import { SelectAdapter } from "@soqs/common";

const SelectComponent = (props) => {
  let { required = false, optionsloading = false, label, ...rest } = props;

  const isNoun = (str) => {
    // Simple check to determine if the first word in the label is a noun
    const nouns = ["a", "e", "i", "o", "u"];
    return nouns.includes(str[0].toLowerCase());
  };

  const isRequired = (x) => {
    const article = isNoun(label) ? "An" : "A";
    return !required || x
      ? undefined
      : `${article} ${label.toLowerCase()} must be selected`;
  };

  return (
    <Field
      required={required}
      label={label}
      fullWidth
      validate={isRequired}
      component={SelectAdapter}
      loading={optionsloading}
      subscription={{ touched: true, value: true, error: true }}
      {...rest}
    />
  );
};

export default SelectComponent;
